// @flow

import gql from 'graphql-tag';
import React, { type Node } from 'react';
import { get } from 'lodash';

import { Query } from '@apollo/react-components'; // eslint-disable-line no-restricted-syntax

import { type AccountChoiceType } from '@zapier/team';

type ChilrenProps = {
  isLoading: boolean,
  joinableAccounts: Array<AccountChoiceType>,
};

type Props = {
  children: ChilrenProps => Node,
  skip?: boolean,
};

const joinableAccountsQuery = gql`
  query WithAccountAccess {
    joinableAccounts {
      accessRequested
      canJoin
      id
      isEmailVerificationRequired
      imageUrl
      name
      owner {
        id
        email
      }
    }
  }
`;

const WithAccountAccess = (props: Props) => {
  return (
    <Query query={joinableAccountsQuery} skip={props.skip}>
      {queryResults =>
        props.children({
          isLoading: queryResults.loading,
          joinableAccounts: get(queryResults, ['data', 'joinableAccounts'], []),
        })
      }
    </Query>
  );
};

export default WithAccountAccess;
